import { FC } from "react";
import { NavLink } from "react-router";
import { isMobile } from "react-device-detect";
import Button from "../../../components/ui/Button";
import appStore from "../../../stores/appStore";

const AccountNavigation: FC = () => {
  const navItems = [
    { path: "/profile", label: "Мои заказы",   end: true},
    { path: "/profile/favorites", label: "Избранное" },
    { path: "/profile/settings", label: "Настройки аккаунта" },
  ];

  return (
    <div className="flex flex-col gap-[18px]">
      <nav
        className={`flex ${
          isMobile
            ? "flex-col overflow-x-auto p-[15px] gap-[20px] whitespace-nowrap bg-[rgba(255, 255, 255, 1)] rounded-[20px] shadow-[0_2px_20px_#0000001a]"
            : "flex-col rounded-[20px] h-max bg-white p-[20px] gap-[20px] min-w-[350px] shadow-[0_2px_20px_#0000001a]"
        }`}
      >
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item?.end}
            className={({ isActive }) =>
              `${
                isMobile ? " !font-bold " : "text-[18px] tracking-[-0.02em]"
              } font-semibold cursor-pointer transition-colors ${
                isActive
                  ? "text-[#383181]"
                  : `${isMobile ? 'text-[rgba(35, 35, 35, 1)] ' : 'text-gray-600 '} hover:text-[#383181]`
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      {
        !isMobile && (
      <Button
        onClick={() => appStore.logout()}
        style="secondary"
        className="!bg-transparent !text-[#B21913] !text-left !p-0 !pl-[20px]"
      >
        Выйти из аккаунта
      </Button>
        )
      }
    </div>
  );
};

export default AccountNavigation;
